module.exports = __webpack_public_path__ + "static/img/bg.0c49032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myprize/bg.png
// module id = fz+7
// module chunks = 1